import PropTypes                     from 'prop-types';
import { serviceProviderDraftShape } from './serviceProviderDraft';
import randomString                  from '../utils/randomString';


const serviceProviderShape = Object.assign(
  {},
  serviceProviderDraftShape,
  {slug: PropTypes.string.isRequired}
);


const serviceProviderPropType = PropTypes.shape(serviceProviderShape);


const generageMockServiceProvider = () => {

  const id = randomString(32);

  const slug = randomString(32);

  return {
    '@id':   '/services/' + id,
    '@type': 'http://schema.org/Thing',
    id,
    name:    randomString(),
    slug,
  };

};


export {
  serviceProviderPropType,
  serviceProviderShape,
  generageMockServiceProvider,
};


// WEBPACK FOOTER //
// ./src/domain/serviceProvider.js